export default function Footer() {
  return (
    <footer id="footer" className="bg-background-100 border-t border-background-200/60">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">

          <div className="lg:col-span-1">
            <h3 className="text-lg font-heading text-primary-500 mb-4">黑料在线</h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              黑料在线⚡专注整理暴走黑料、黑料社等特色黑料系列内容，每日更新热门合辑，
              提供暴走黑料在线观看与黑料社在线观看服务，满足广大网友系列化吃瓜需求。
              本站所有内容均来自公开网络信息整理，仅供娱乐参考。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-500 hover:bg-primary-500/10 transition-colors cursor-pointer">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-500 hover:bg-primary-500/10 transition-colors cursor-pointer">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:text-primary-500 hover:bg-primary-500/10 transition-colors cursor-pointer">
                <i className="ri-vidicon-line"></i>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-700 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <a href="#topics" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">话题热榜</a>
              <a href="#updates" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">最新快讯</a>
              <a href="#ranking" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">热门排行</a>
              <a href="#index" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">专题索引</a>
              <a href="#carousel" className="text-sm text-foreground-500 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">热门专题</a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-700 mb-4">特色系列</h4>
            <div className="flex flex-col gap-2.5">
              <span className="text-sm text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors whitespace-nowrap">暴走黑料系列</span>
              <span className="text-sm text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors whitespace-nowrap">黑料社精选</span>
              <span className="text-sm text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors whitespace-nowrap">吃瓜日报</span>
              <span className="text-sm text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors whitespace-nowrap">深扒专题</span>
              <span className="text-sm text-foreground-500 cursor-pointer hover:text-primary-500 transition-colors whitespace-nowrap">热门合辑</span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-700 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-400 leading-relaxed">
              期待与更多优质内容平台合作，共建健康有趣的娱乐资讯生态。
            </p>
            <div className="mt-4">
              <a
                href="#contact"
                className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-400 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                商务合作
              </a>
            </div>
          </div>

        </div>

        <div className="mt-12 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 黑料在线. 本站内容仅供娱乐参考，不构成任何建议。
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-foreground-500 transition-colors">用户协议</span>
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-foreground-500 transition-colors">隐私政策</span>
            <span className="text-xs text-foreground-400 cursor-pointer hover:text-foreground-500 transition-colors">免责声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}